import styled from '@emotion/styled'
import { FusionInterfaceZIndex } from '../../../theme/FusionStyle'
import { V2L1LoadingIndicator } from '../Indicator/V2L1LoadingIndicator'

const V2L5LoadingOverlayRoot = styled.div({
	position: 'fixed',
	top: 0,
	left: 0,
	width: '100vw',
	maxWidth: '100vw',
	height: '100vh',
	maxHeight: '100vh',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: FusionInterfaceZIndex.Overlay,
})

interface V2L5LoadingOverlayProps {
	loading?: boolean
}

export const V2L5LoadingOverlay = ({loading}: V2L5LoadingOverlayProps) => {
	if(!loading) {
		return null
	}
	return (
		<V2L5LoadingOverlayRoot>
			<V2L1LoadingIndicator big />
		</V2L5LoadingOverlayRoot>
	)
}
